import {
  IMeasureFilterValue,
  RowType,
} from '../../../../redux/slices/oldBuilder';
import {
  IMeasureFieldsFragment,
  IMeasurePropertiesFieldsFragment,
  QueryType,
} from '../../../../utils/apollo/graphqlSchema';
import { getCharacterByIncrementedIndex } from '../../../../utils/character';

interface IGetQueryMeasureFiltersInfo {
  queryType: QueryType.Expression;
  measure: IMeasureFieldsFragment;
  measureProperties: IMeasurePropertiesFieldsFragment;
}

interface IGetDataTableMeasureFiltersInfo {
  queryType: QueryType.DataTable;
  measuresProperties: IMeasurePropertiesFieldsFragment[];
}

type IUseGetMeasureFiltersInfoArgs =
  | IGetQueryMeasureFiltersInfo
  | IGetDataTableMeasureFiltersInfo;

const getMeasureFiltersInfo = (
  args: IUseGetMeasureFiltersInfoArgs,
): IMeasureFilterValue[] => {
  const { queryType } = args;

  if (queryType === QueryType.Expression) {
    const { measure, measureProperties } = args;

    if (
      measure.__typename === 'SimpleMeasure' &&
      measureProperties.__typename === 'SimpleMeasureProperties' &&
      measureProperties?.filter
    ) {
      return [
        {
          rowMeta: {
            rowType: RowType.measures,
            rowIndex: 0,
          },
          filter: measureProperties.filter,
          measureKey: getCharacterByIncrementedIndex('A', 0),
        },
      ];
    }

    if (
      measure.__typename === 'CompoundMeasure' &&
      measureProperties.__typename === 'CompoundMeasureProperties'
    ) {
      const { measures } = measureProperties;
      const result: IMeasureFilterValue[] = [];

      measures.forEach((measure, index) => {
        if (measure?.filter) {
          result.push({
            rowMeta: {
              rowType: RowType.measures,
              rowIndex: index,
            },
            filter: measure.filter,
            measureKey: getCharacterByIncrementedIndex('A', index),
          });
        }
      });

      const formula = measure?.formula;

      if (measureProperties?.resultFilter && formula) {
        result.push({
          rowMeta: {
            rowType: RowType.global,
            rowIndex: -1,
          },
          filter: measureProperties.resultFilter,
          measureKey: formula,
        });
      }

      return result;
    }

    return [];
  }

  const { measuresProperties } = args;

  return measuresProperties.reduce<IMeasureFilterValue[]>(
    (acc, measureProperty, index) => {
      if (
        measureProperty.__typename === 'SimpleMeasureProperties' &&
        measureProperty?.filter
      ) {
        acc.push({
          rowMeta: {
            rowType: RowType.dataTableMeasures,
            rowIndex: index,
          },
          filter: measureProperty.filter,
          measureKey: getCharacterByIncrementedIndex('A', index),
        });
      } else if (
        measureProperty.__typename === 'CompoundMeasureProperties' &&
        measureProperty?.resultFilter
      ) {
        acc.push({
          rowMeta: {
            rowType: RowType.dataTableMeasures,
            rowIndex: index,
          },
          filter: measureProperty.resultFilter,
          measureKey: getCharacterByIncrementedIndex('A', index),
        });
      }

      return acc;
    },
    [],
  );
};

export default getMeasureFiltersInfo;
